<template>
  <div class="py-3">
    <b-row>
      <b-col class="text-center text-md-left">
        <h2 v-show="!registerCompanyOnly" v-translate>Create a new account</h2>
        <h2 v-show="registerCompanyOnly" v-translate>Please, register your company</h2>
        <div v-if="!this.$store.getters.ecosystem.restrictRegisterToCountry">
          <p v-translate>Please, confirm or change your country below.</p>
          <form @submit.prevent="setNewCountry()" class="my-5">
            <b-input-group>
              <b-form-select v-model="country" :options="this.countries.map(x => { if(!x.front_config.hideFromSelect || showAllCountries) return {value: x.iso_code, text: x.name} }).filter(Boolean)" class="form-control" style="font-size: 2rem">
                <template #first>
                  <option :value="null">Select/Selecciona</option>
                </template>
              </b-form-select>
              <b-input-group-append>
                <b-button variant="primary" type="submit" size="lg">
                    <b-spinner small v-if="sending"></b-spinner>
                    <strong v-show="!countryConfirmed" v-translate>Continue</strong>
                    <strong v-show="countryConfirmed" v-translate>Change</strong>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </form>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="registerConfig && countryConfirmed">
      <b-col class="text-center text-md-left">
        <div v-if="withTinCheck && (!tinResponse.success || tinResponse.success === false) && (this.registerConfig.allowManualOnFailure === false || (this.registerConfig.allowManualOnFailure === true && failure !== true))">
          <p class="mt-4" v-translate v-show="!registerCompanyOnly">At the moment we work exclusively with legally established companies so before start, please, enter your company TIN below.</p>
          <p class="mt-4" v-translate v-show="registerCompanyOnly">Due to some changes to ensure the best service we work (for now) exclusively with legally established companies so before start operating, please, enter your company TIN below.</p>
          <form @submit.prevent="checkTin()" class="mt-5">
            <b-row>
              <b-col>
                <b-input-group>
                  <b-input class="form-control" style="font-size: 2rem" size="lg" id="register__tin" :placeholder="$gettext('TIN')" v-model="company.tin" required :state="preCheckTin" />
                  <b-input-group-append>
                    <b-button variant="primary" type="submit" size="lg" :disabled="preCheckTin !== null && preCheckTin !== true">
                        <b-spinner small v-if="sending"></b-spinner>
                        <strong v-translate>Search</strong>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
          </form>
        </div>
        <div v-else-if="!withTinCheck || (tinResponse.success || tinResponse.success === true) || (withTinCheck && this.registerConfig.allowManualOnFailure === true && failure === true)">
          <b-alert variant="info" show class="mb-3 py-3" v-if="withTinCheck && (tinResponse.success || tinResponse.success === true)">
              <h4 v-translate>Available Company Info</h4>
              <h3>{{company.business_name}}</h3>
              <h5><translate>TIN</translate> {{company.tin}}</h5>
              <p>
                {{company.address}}
              </p>
              <a href="#" @click.prevent="resetData" v-translate>This is not your company? Search for TIN again</a>
          </b-alert>
          <b-alert variant="info" show class="mb-3 py-3" v-else-if="withTinCheck && this.registerConfig.allowManualOnFailure === true && failure === true">
              <h4 v-translate>Oops! We couldn't find and fetch your company info with the TIN you provided</h4>
              <h5><translate>TIN</translate> {{company.tin}}</h5>
              <p v-translate>Is it OK? You may search for it again clicking the link below or you can manually fill all your company info on the following form</p>
              <a href="#" @click.prevent="resetData" v-translate>Search for TIN again</a>
          </b-alert>
          <form @submit.prevent="register()" class="form form--login grid mb-3" v-if="company.is_created === false">
            <div v-if="withTinCheck && failure === false">
              <h4 class="mt-4" v-translate>Extra Info <small class="text-danger">(required)</small></h4>
              <div class="form-group">
                <input class="form-control" id="company__business_name" :placeholder="$gettext('Fiscal/Legal Name')" v-model="company.business_name" v-if="!company.business_name" required>
              </div>
              <div class="form-group">
                <input class="form-control" id="company__name" :placeholder="$gettext('Brand/Commercial Name')" v-model="company.name" required>
              </div>
              <div class="form-group">
                <b-textarea class="form-control" id="company__address" :placeholder="$gettext('Fiscal/Legal Address')" v-model="company.address" v-if="!company.address" required />
              </div>
            </div>
            <div v-else>
              <p class="mt-4" v-translate v-show="!registerCompanyOnly && !failure">At the moment we work exclusively with legally established companies so before start, please, enter your company information below.</p>
              <p class="mt-4" v-translate v-show="registerCompanyOnly && !failure">Due to some changes to ensure the best service we work (for now) exclusively with legally established companies so before start operating, please, enter your company information below.</p>
              <h4 class="mt-4" v-translate>Basic Info <small class="text-danger">(required)</small></h4>
              <div class="form-group">
                <input class="form-control" id="company__tin" :placeholder="$gettext('TIN')" v-model="company.tin" required>
              </div>
              <div class="form-group">
                <input class="form-control" id="company__business_name" :placeholder="$gettext('Fiscal/Legal Name')" v-model="company.business_name" required>
              </div>
              <div class="form-group">
                <input class="form-control" id="company__name" :placeholder="$gettext('Brand/Commercial Name')" v-model="company.name" required>
              </div>
              <div class="form-group">
                <b-textarea class="form-control" id="company__address" :placeholder="$gettext('Fiscal/Legal Address')" v-model="company.address" required />
              </div>
            </div>
            <h5 class="mt-4" v-translate>Industries <small class="text-danger">(required)</small></h5>
            <b-form-text v-translate class="text-muted mb-2">Please select one or more</b-form-text >
            <div class="form-group">
              <b-form-checkbox-group v-model="company.industries">
                <b-form-checkbox class="w-50 mr-0" v-for="(i, index) in industries.map(x => {return {text: x.description, value: x.id}})" :value="i.value" :key="index">{{i.text === 'Other' ? $pgettext('fem', 'Other') : i.text}}</b-form-checkbox>
              </b-form-checkbox-group>
            </div>
            <h5 class="mt-4" v-translate>Commercial Contact <small class="text-danger">(required)</small></h5>
            <div class="form-group">
              <input type="text" :placeholder="$gettext('Name')" class="form-control" id="company__commercial__name" v-model="company.contact_name" required>
            </div>
            <div class="form-group">
              <input type="text" :placeholder="$gettext('Phone')" class="form-control" id="company__commercial__phone" v-model="company.phone" required>
            </div>
            <div class="form-group">
              <input type="email" :placeholder="$gettext('E-mail')" class="form-control" id="company__commercial__email" v-model="company.email" required>
            </div>
            <h5 class="mt-4" v-translate>Billing Contact <small class="text-danger">(required)</small></h5>
            <div class="form-group">
              <input type="text" :placeholder="$gettext('Name')" class="form-control" id="company__billing__name" v-model="company.billing_details.name" required>
            </div>
            <div class="form-group">
              <input type="text" :placeholder="$gettext('Last Name')" class="form-control" id="company__billing__last_name" v-model="company.billing_details.last_name" required>
            </div>
            <div class="form-group">
              <input type="text" :placeholder="$gettext('Phone')" class="form-control" id="company__billing__phone" v-model="company.billing_details.phone" required>
            </div>
            <div class="form-group" v-for="(item, index) in company.billing_details.emails" :key="index">
              <b-input-group>
                <b-input type="email" :placeholder="$gettext('E-mail')" class="form-control" :id="'company__billing__email' + index" v-model="company.billing_details.emails[index]" required />
                <b-input-group-append>
                  <b-button size="sm" variant="danger" @click="removeBillingDetailsEmail(index)" style="padding-top: initial; padding-bottom: initial;">
                      <strong>✕</strong>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <form @submit.prevent="addBillingDetailsEmail" v-if="company.billing_details.emails.length < 5">
              <b-input-group>
                <input type="email" :placeholder="$gettext('E-mail')" class="form-control" id="company__billing__email" v-model="newBillingDetailsEmail" required @blur="$refs.argh.click()" />
                <b-input-group-append>
                  <b-button size="sm" ref="argh" variant="success" :disabled="newBillingDetailsEmail === ''" type="submit" style="padding-top: initial; padding-bottom: initial;">
                      <strong>＋</strong>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-text v-translate>Up to 5 e-mail addresses that will receive our invoices.</b-form-text>
            </form>
            <div v-if="!registerCompanyOnly">
              <h5 class="mt-4" v-translate>New User <small class="text-danger">(required)</small></h5>
              <p v-translate>This is the information you will need to log in into the system and to administrate your company users.</p>
              <div class="form-group">
                <input type="text" :placeholder="$gettext('Your Name')" class="form-control" id="login__name" v-model="user.name" required>
              </div>
              <div class="form-group label-floating">
                <input type="email" :placeholder="$gettext('E-mail')" class="form-control" id="login__email" v-model="user.email" required>
              </div>
              <div class="form-group">
                <password ref="pwd_check" min="8" v-model="user.password" :placeholder="$gettext('Password')" inputClass="form-control" />
                <b-form-text v-translate>8 characters minimum, far better with upper and lower case letters, numbers and symbols</b-form-text>
              </div>
            </div>
            <h4 class="mt-4" v-translate>Other Info <small class="text-muted">(optional)</small></h4>
            <b-row>
              <b-col>
                <h6 v-translate>E-commerce Technologies</h6>
                <div class="form-group">
                  <b-form-checkbox-group v-model="company.e_commerce_techs" stacked :options="techs.map(x => {return {text: x.description, value: x.id}})">
                  </b-form-checkbox-group>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="form-group mt-4">
                  <b-form-checkbox v-model="user.terms" required>
                    <span v-translate>I've read and agree to the <a href="https://moova.io/terminos-y-condiciones/" target="_blank">Terms and Conditions</a> and the <a href="https://moova.io/politica-de-privacidad/" target="_blank">Privacy Policy</a></span>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" order="1" order-md="1" class="text-center mt-4">
                <button type="submit" class="btn btn-lg btn-primary" :disabled="!formCompleted">
                  <b-spinner small v-if="sending"></b-spinner>
                  <strong v-show="!registerCompanyOnly" v-translate>Sign up</strong>
                  <strong v-show="registerCompanyOnly" v-translate>Register Your Company</strong>
                </button>
              </b-col>
              <b-col md="12" order="12" order-md="2" class="text-center" v-show="!registerCompanyOnly">
                <p class="forgot">
                  <router-link to="password/reset" v-translate>Forgot password?</router-link>
                </p>
              </b-col>
            </b-row>
          </form>
          <b-alert variant="warning" show v-else>
              <h2 v-translate>The company already exists into our system</h2>
              <h4 v-translate>You must contact the person on your company who administer the Moova Dashboard and ask them for your user creation.</h4>
          </b-alert>
        </div>
      </b-col>
      <div class="overlay" v-if="sending"></div>
      <span class="d-none" v-translate>Your Name</span>
      <translate class="d-none">TIN</translate>
      <translate class="d-none">Brand/Commercial Name</translate>
      <translate class="d-none">Fiscal/Legal Name</translate>
      <translate class="d-none">Fiscal/Legal Address</translate>
      <translate class="d-none" translate-context="fem">Other</translate>
    </b-row>
  </div>
</template>
<script>
import Password from '@/components/Password'
import checkTinLocal from '@/common/checkTinLocal'

export default {
  name: 'RegisterPage',
  title() {
    return this.$gettext('Create a new account')
  },
  components: {
    Password
  },
  data() {
    return {
      registerConfig: this.$frontConfig.register,
      country: this.$cookies.get('country'),
      countryConfirmed: false,
      industries: [],
      techs: [],
      tinResponse: {},
      newBillingDetailsEmail: '',
      failure: false,
      company: {
        name: '',
        tin: '',
        address: '',
        contact_name: '',
        phone: '',
        email: '',
        billing_details: {
          name: '',
          last_name: '',
          phone: '',
          emails: []
        },
        industries: [],
        e_commerce_techs: [],
        is_created: false
      },
      user: {
        name: '',
        email: '',
        password: '',
        terms: false
      },
      sending: false
    }
  },
  computed: {
    formCompleted() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (this.registerCompanyOnly) {
        return this.company.tin &&
          this.company.business_name &&
          this.company.name &&
          this.company.address &&
          this.company.industries.length > 0 &&
          this.company.contact_name &&
          this.company.phone &&
          this.company.email &&
          this.company.billing_details.name &&
          this.company.billing_details.last_name &&
          this.company.billing_details.phone &&
          (this.company.billing_details.emails.length > 0 || re.test(this.newBillingDetailsEmail)) &&
          this.user.terms
      } else {
        return this.company.tin &&
          this.company.business_name &&
          this.company.name &&
          this.company.address &&
          this.company.industries.length > 0 &&
          this.company.contact_name &&
          this.company.phone &&
          this.company.email &&
          this.company.billing_details.name &&
          this.company.billing_details.last_name &&
          this.company.billing_details.phone &&
          (this.company.billing_details.emails.length > 0 || re.test(this.newBillingDetailsEmail)) &&
          this.user.name &&
          this.user.email &&
          this.user.password &&
          this.user.terms
      }
    },
    registerCompanyOnly() {
      return this.$store.getters.profile && this.$store.getters.profile.company_id === null
    },
    withTinCheck() {
      return this.registerConfig && this.registerConfig.checkTin === true && (!this.tinResponse.success || this.tinResponse.success !== true)
    },
    preCheckTin() {
      if (this.registerConfig.preCheckTin && this.company.tin.length > 0) {
        const match = this.company.tin.match(new RegExp((this.registerConfig.preCheckTin), 'gi'))

        return !!match
      } else {
        return null
      }
    },
    showAllCountries() {
      return this.$route.query.all
    }
  },
  created() {
    this.fetchCountries()
    this.fetchMktgStuff()
  },
  mounted() {
    if (this.$store.getters.ecosystem.restrictRegisterToCountry) {
      this.countryConfirmed = true
    }
  },
  methods: {
    setNewCountry() {
      if (this.country !== null) {
        this.$frontConfig = this.countries.find(x => x.iso_code === this.country).front_config || null
        this.$cookies.set('country', this.country, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$cookies.set('phonePrefix', this.$frontConfig.i18n.phonePrefix, 60 * 60 * 24 * 30, null, null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$emit('countryChanged')
      }
      if (this.$frontConfig) {
        this.$language.current = this.$frontConfig.i18n.lang || 'en_US'
        const moment = this.$frontConfig.i18n.moment || 'en'
        this.moment.locale(moment)
      }
      this.resetData()
    },
    addBillingDetailsEmail() {
      this.company.billing_details.emails.push(this.newBillingDetailsEmail)
      this.newBillingDetailsEmail = ''
    },
    removeBillingDetailsEmail(index) {
      this.company.billing_details.emails.splice(index, 1)
    },
    fetchMktgStuff() {
      let params = {
        filter_groups: [
          {
            filters: [
              ['type', 'eq', 'e-commerce-tech']
            ]
          }
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'marketing-catalogs', { params })
        .then(response => {
          this.techs = response.body.data
        })

      params = {
        filter_groups: [
          {
            filters: [
              ['type', 'eq', 'industry']
            ]
          }
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'marketing-catalogs', { params })
        .then(response => {
          this.industries = response.body.data
        })
    },
    checkTin() {
      this.sending = true
      if (this.registerConfig.endpoint) {
        this.$http.get(this.$appConfig.api.baseUrl + this.registerConfig.endpoint.replace('{tin}', this.company.tin.replace(/[^a-zA-Z0-9]/g, '')))
          .then(response => {
            this.company = { ...this.company, ...this.remapResponse(response.body, this.registerConfig.mapResponse) }
            Object.keys(this.company).forEach(key => {
              if (key.indexOf('raw') === -1) {
                this.company[key] = this.company[key] !== '-' && this.company[key] !== '' ? this.company[key] : null
              }
            })

            this.tinResponse.success = true
            this.sending = false
          }, error => {
            this.sending = false
            if (this.registerConfig.allowManualOnFailure === true) {
              this.failure = true
            } else {
              let message = ''
              if (error.status === 404) {
                message = this.$gettext('The TIN has not been found or it\'s invalid. Please, check the number and try again')
              } else {
                message = this.$gettext('There were an error. Please, try again.')
              }
              const obj = {
                title: 'ERROR',
                message,
                type: 'error',
                customCloseBtnText: this.$gettext('Close')
              }
              this.$root.$children[0].$refs.simplert.openSimplert(obj)
            }
          })
      } else if (checkTinLocal[this.$cookies.get('country')].doCheck(this.company.tin)) {
        this.tinResponse.success = true
        this.failure = true
        this.sending = false
      } else {
        this.sending = false
        if (this.registerConfig.allowManualOnFailure === true) {
          this.failure = true
        } else {
          const message = this.$gettext('The TIN has not been found or it\'s invalid. Please, check the number and try again')
          const obj = {
            title: 'ERROR',
            message,
            type: 'error',
            customCloseBtnText: this.$gettext('Close')
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        }
      }
    },
    remapResponse(o, r) {
      o = this.flattenObject(o)
      return Object.keys(o).map((key) => ({ [r[key] || key]: o[key] })).reduce((a, b) => Object.assign({}, a, b))
    },
    flattenObject(objectOrArray, prefix = '', formatter = (k) => (k)) {
      const nestedFormatter = (k) => ('.' + k)
      const nestElement = (prev, value, key) => (
        (value && typeof value === 'object')
          ? { ...prev, ...this.flattenObject(value, `${prefix}${formatter(key)}`, nestedFormatter) }
          : { ...prev, ...{ [`${prefix}${formatter(key)}`]: value } })

      return Array.isArray(objectOrArray)
        ? objectOrArray.reduce(nestElement, {})
        : Object.keys(objectOrArray).reduce(
          (prev, element) => nestElement(prev, objectOrArray[element], element),
          {}
        )
    },
    register() {
      this.company.country_iso_code = this.$cookies.get('country')
      if (this.failure) {
        this.company.meta = {
          manualData: true
        }
      }
      if (this.registerCompanyOnly) {
        this.sending = true
        this.company.user_id = this.$store.getters.profile.id
        this.$http.post(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/companies', this.company)
          .then(response => {
            window.location.href = window.location.origin
          }, error => {
            this.sending = false
            let message = ''
            if (error.status === 422) {
              for (const errorItem of error.body.errors) {
                message += '- ' + errorItem.detail + '<br>'
              }
            } else if (error.status === 409) {
              message = this.$gettext('The company already exists into our system') + '. ' + this.$gettext('You must contact the person on your company who administer the Moova Dashboard and ask them for your user creation.')
            } else {
              message = this.$gettext('There were an error creating the company. Please, try again.')
            }
            const obj = {
              title: 'ERROR',
              message,
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
          })
      } else if (this.$refs.pwd_check.has_length && this.$refs.pwd_check.pwd_score >= 40) {
        this.sending = true
        this.$http.post(this.$appConfig.api.baseUrl + 'users/', {
          name: this.user.name,
          email: this.user.email,
          password: this.$refs.pwd_check.password,
          country_iso_code: this.$cookies.get('country'),
          terms: this.user.terms
        }).then(response => {
          this.$http.post(this.$appConfig.api.baseUrl + 'users/' + response.body.id + '/companies', this.company)
            .then(response => {
              this.$router.push('/login?r=true')
            })
        }, error => {
          this.sending = false
          let message = ''
          if (error.status === 422) {
            for (const errorItem of error.body.errors) {
              message += '- ' + errorItem.detail + '<br>'
            }
          } else if (error.status === 404) {
            message = this.$gettext('Sorry! We still don\'t bring services in your country :(')
          } else {
            message = this.$gettext('The email is already registered<br><br>Please <a href=/login>log in</a> with your previous credentials<br>or<br><a href=/password/reset>click here</a> if you forgot your password') // error.body.message
          }
          const obj = {
            title: 'ERROR',
            message,
            type: 'error',
            customCloseBtnText: this.$gettext('Close')
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
      }
    },
    authenticate(provider) {
      this.$store.dispatch('authenticate', { provider }).then(() => {
        this.$router.push('search')
      })
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.countryConfirmed = true
      this.fetchCountries()
      this.fetchMktgStuff()
    }
  }
}
</script>

<style lang="scss">
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .5);
  top: 0;
  left: 0;
  z-index: 15;
}
</style>
